import React from 'react';
import './DetalheVolume.css';

function ModalPdf({ blobUrl, produto, onClose }) {
  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = `ENG-006-${produto}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="pal-modal-overlay" onClick={handleOverlayClick}>
      <div className="pal-modal">
        <div className="pal-modal-header">
          <span className="pal-modal-title">ENG-006-{produto} — Plano de Paletização</span>
          <div className="pal-modal-actions">
            <button className="pal-btn-secondary" onClick={handleDownload}>
              Baixar
            </button>
            <button className="pal-btn-ghost" onClick={onClose}>
              Fechar
            </button>
          </div>
        </div>

        <div className="pal-modal-status" style={{ padding: '0.5rem 1.25rem' }}>
          Baixe o PDF antes de fechar; esta pr&eacute;via n&atilde;o fica salva no servidor.
        </div>
        <div className="pal-modal-body">
          <iframe
            src={blobUrl}
            title="PDF Preview"
            className="pal-modal-iframe"
          />
        </div>
      </div>
    </div>
  );
}

export default ModalPdf;
